module.exports = __webpack_public_path__ + "static/john-lennon-headshot.ce478423.jpg";